<template>
  <v-card :class="[mapSidePanelClasses, panelState]" flat>
    <transition name="fade">
      <button v-show="panelState" @click="closePanel()" class="panel-close">
        <v-icon color="#235592">mdi-close</v-icon>
      </button>
    </transition>
    
    <div class="card-wrapper">
      <div class="px-4 px-md-12 mb-6">
        <p class="text-nav-anchor text--fes-blue mb-4">City Profile</p>

        <p class="text-hero text--fes-blue mb-3">{{ panelContent.city }}</p>
    
        <div class="card-city-name">
          <img src="@/assets/map/map-panel/map-panel-location-icon.svg" />
          <p class="text-nav-anchor text--fes-blue mb-0">
            {{ panelContent.country }}
          </p>
        </div>
      </div>

      <img 
        v-if="panelContent.city"
        :src="require('@/assets/map/cities/' + `${kebabCase(panelContent.city)}` + '.png')"
        width="100%"
        class="mb-12"
      />

      <div class="px-4 px-md-12 mb-12">
        <p class="text-card text--fes-magenta mb-4">Challenges for social-ecological transformation</p>

        <div v-if="introduction_para" class="text--fes-blue content-block">
          <p v-for="(text, i) in introduction_para" :key="'text-' + i" class="text-body" v-html="text.value">
          </p>
        </div>
      </div>

      <div class="px-4 px-md-12 mb-12">
        <p class="text-card text--fes-magenta mb-4">About {{ panelContent.city }}</p>

        <v-row dense align="stretch" justify="start" v-if="cardMultiples">
          <v-col
            v-for="n in cardMultiples" 
            :key="n.id + '-mapCards'"
            cols="12" :md="n.cols"          
            class="content-map-cards d-flex">
              <div class="pa-6 mb-4 mb-md-6 card-item" :style="{ backgroundColor: n.color }">
                <div>
                  <div class="mb-4">
                    <p 
                      :class="['text-data-header mb-0', n.textColor]" 
                      :style="{ height: n.cols === '4' || n.cols === '8' ? '28px' : 'auto' }">
                      {{ n.label }}
                    </p>
                    <p v-if="n.sublabel" :class="[n.textColor, 'text-body-xs mt-2 font-italic']">{{ n.sublabel }}</p>
                  </div>
                  

                  <!-- content of box is amount  -->
                  <div v-if="n.amt" class="sub-card">
                    <p :class="[n.textColor, 'mb-1']">
                      <span class="text-section">{{ n.amt }} </span>
                      <span class="text-body">{{ n.unit }}</span>
                    </p>
                    <p :class="['text-fes-caption font-italic mb-0', n.textColor]">({{ n.year }}</p>
                  </div>

                  <!-- content of box is emission  -->
                  <div v-else-if="n.emissions">
                    <p :class="[n.textColor, 'mb-1 text-body']">
                      {{ n.emissions }} {{ n.reduction_pre }} 
                      <span class="text-section">{{ n.reduction_value }}</span>{{ n.reduction_post }}
                    </p>
                  </div>

                  <!-- content of box is text -->
                  <!-- <div v-else-if="n.text" :class="[n.textColor]" v-html="n.text"/> -->
                  <div v-else-if="n.text" :class="[n.textColor]">
                    <p v-for="(text, i) in n.text" :key="'text-' + i" v-html="text.value" class="text-body"/>
                  </div>

                  <!-- content of box is index -->
                  <div v-else-if="n.index" class="sub-card">
                    <p :class="['text-section mb-2', n.textColor]">
                      {{ n.index }} 
                      <span :class="['text-fes-caption font-italic mb-0', n.textColor]">{{ n.cite }}</span>
                    </p>
                  </div>
                </div>

                <img :src="require('@/assets/map/map-panel/' + `${n.id}` + '.svg')" class="card-icon mt-md-4" />
              </div>
          </v-col>  
                                              
          <v-col cols="12" class="mt-4">
            <p class="text-fes-caption font-italic mb-1 text--fes-blue">
              Sources for the data above can be found <router-link :to="'/references'">here</router-link>.
            </p>

            <!-- <p class="text-fes-caption font-italic mb-1 text--fes-blue">
              *Poverty index: percentage of the population living below the national poverty line(s)
            </p> -->

            <!-- <p class="text-fes-caption font-italic text--fes-blue">
              **Gini coefficient: A country-level measure of inequality that ranges between 0 to 1. 0 refers to perfect equality and 1 refers to perfect inequality.
            </p>                          -->
          </v-col>
        </v-row>
      </div>

      <div v-if="videoList.length">
        <div 
          v-for="(item, i) in videoList" :key="i + '-video'"
          class="content-video-wrapper px-4 px-md-12 mb-12">
          <iframe class="video" :src="item.value" />     
        </div>
      </div>
 
      <div class="px-4 px-md-12 mb-12" v-if="referenceList.length">
        <p class="text-card text--fes-magenta mb-4">Learn more</p>

        <div class="card-learn-more mb-6 mb-md-8" v-for="ref in referenceList" :key="ref.title + '-map'">
          <v-row align="start">
            <v-col cols="4" md="3">
              <img v-if="ref.image" :src="require('@/assets/map/covers/' + `${ref.image}`)" width="100%" />
              <img v-else src="@/assets/references/placeholder.png" width="100%" />
              <!-- <img src="@/assets/references/placeholder.png" width="100%" /> -->
            </v-col>

            <v-col cols="8" md="9">
              <p class="text-body-xs text--fes-blue mb-3">{{ ref.author }}</p>
              <p class="text-body text--fes-blue mb-4 font-weight-bold">
                <a :href="ref.link" target="_blank">{{ ref.title }}</a>
              </p>
              <p class="text-body-xs text--fes-blue mb-0">{{ ref.date }}</p>
            </v-col>    
          </v-row>
        </div>
      </div> 

      <div class="px-4 px-md-12 mb-0" v-if="partnerList.length">
        <p class="text-card text--fes-magenta mb-4">Find out more from our partners in {{ panelContent.city }}
          <span v-if="panelContent.partner_location">and across {{ panelContent.country }}</span>
        </p>

        <div class="card-references">
          <p class="text-body text--fes-blue mb-6 font-weight-bold" v-for="(partner, i) in partnerList" :key="i + '-map-partner'">
            {{ partner.name }} <br>
            <span class="text-body-xs text--fes-blue mt-1" v-if="partner.link">
              <a :href="partner.link" target="_blank">{{ partner.link }}</a>  
            </span>
          </p>
        </div>
      </div>            
    </div>
  </v-card>
</template>

<script>
import _kebabCase from 'lodash.kebabcase';
import { mapGetters } from 'vuex';

export default {
  name: 'MapSidePanel', 
  computed: {
    mapSidePanelClasses() {
      return {
        'map-side-panel--desktop map-side-panel': this.$vuetify.breakpoint.mdAndUp,
        'map-side-panel--mobile map-side-panel py-6': this.$vuetify.breakpoint.smAndDown,
      };
    },
     ...mapGetters('contentPanel', ['panelState', 'panelContent']),
    introduction_para() {
      if (this.panelContent.city) {
        const item = JSON.parse(this.panelContent.introduction_para);
        return item;
      } else {
        return '';
      }
    },
    cardMultiples() {
      if (this.panelContent.city) {
        const item = this.panelContent;
        const allVehicles = ['Seoul', 'Iloilo City', 'Cebu City']
        if (allVehicles.includes(item.city)) {
          const hellow = [
            {
              id: 'inhabitants',
              color: '#E9ECFB',
              amt: item.population.split(" ")[0],
              unit: item.population.split(" ")[1],
              year: item.population.split(" (")[1],
              label: 'No. of inhabitants',
              textColor: 'text--fes-blue',
              cols: "4"
            }, 
            {
                id: 'cars', // vehicles
                color: '#E9ECFB',
                amt: item.vehicles? item.vehicles.split(" ")[0]: 'none',
                unit: 'vehicles',
                year: item.vehicles ? item.vehicles.split(" (")[1] : '',            
                label: 'No. of vehicles per 100 people',
                textColor: 'text--fes-blue',
                cols: "8"                        
            },  
            {
                id: 'transport',
                color: '#E9ECFB',
                text: JSON.parse(item.public_transport),
                label: 'Public transportation',
                textColor: 'text--fes-blue',
                cols: "12"
            }, 
            {
                id: 'carbon-emissions',
                color: '#EAF4E4',
                emissions: item.co2,
                reduction_pre: item.carbon_reduction.split("/")[0],
                reduction_value: item.carbon_reduction.split("/")[1],
                reduction_post: item.carbon_reduction.split("/")[2],
                label: 'Carbon emissions target',
                textColor: 'text--fes-green',
                cols: "12"
            },           
            {
                id: 'gini-coefficient',
                color: '#ECF6F9',
                index: item.gini_coefficient.split("/")[0],
                cite: item.gini_coefficient.split("/")[1],            
                label: 'Gini Coefficient',
                sublabel: 'A country-level measure of inequality that ranges between 0 to 1. 0 refers to perfect equality and 1 refers to perfect inequality.',
                textColor: 'text--fes-blue',
                cols: "12"
            }, 
            {
                id: 'housing',
                color: '#F1E3ED',
                text: JSON.parse(item.housing),
                label: 'Housing',
                textColor: 'text--fes-magenta',
                cols: "12"
            },   
          ]
          return hellow;
        } else {
          const hellow = [
            {
              id: 'inhabitants',
              color: '#E9ECFB',
              amt: item.population.split(" ")[0],
              unit: item.population.split(" ")[1],
              year: item.population.split(" (")[1],
              label: 'No. of inhabitants',
              textColor: 'text--fes-blue',
              cols: "4"
            }, 
            {
                id: 'cars',
                color: '#E9ECFB',
                amt: item.cars ? item.cars.split(" ")[0] : 'none',
                unit: 'cars',
                year: item.cars ? item.cars.split(" (")[1] : '',            
                label: 'No. of cars per 100 people',
                textColor: 'text--fes-blue',
                cols: "4"            
            }, 
            {
                id: 'motorbikes',
                color: '#E9ECFB',
                amt: item.motorbikes ? item.motorbikes.split(" ")[0] : 'none', 
                unit: 'motorbikes',
                year: item.motorbikes ? item.motorbikes.split(" (")[1]: '',            
                label: 'No. of motorbikes per 100 people',
                textColor: 'text--fes-blue',
                cols: "4"                        
            },
            {
                id: 'transport',
                color: '#E9ECFB',
                text: JSON.parse(item.public_transport),
                label: 'Public transportation',
                textColor: 'text--fes-blue',
                cols: "12"
            }, 
            {
                id: 'carbon-emissions',
                color: '#EAF4E4',
                emissions: item.co2,
                reduction_pre: item.carbon_reduction.split("/")[0],
                reduction_value: item.carbon_reduction.split("/")[1],
                reduction_post: item.carbon_reduction.split("/")[2],
                label: 'Carbon emissions target',
                textColor: 'text--fes-green',
                cols: "12"
            },           
            // {
            //     id: 'poverty',
            //     color: '#ECF6F9',
            //     index: item.poverty_index.split(" ")[0],
            //     cite: item.poverty_index.split("% ")[1],            
            //     label: 'Poverty index*',
            //     textColor: 'text--fes-blue',
            //     cols: "4"
            // }, 
            {
                id: 'gini-coefficient',
                color: '#ECF6F9',
                index: item.gini_coefficient.split("/")[0],
                cite: item.gini_coefficient.split("/")[1],            
                label: 'Gini Coefficient',
                sublabel: 'A country-level measure of inequality that ranges between 0 to 1. 0 refers to perfect equality and 1 refers to perfect inequality.',
                textColor: 'text--fes-blue',
                cols: "12"
            }, 
            // {
            //     id: 'employment',
            //     color: '#ECF6F9',
            //     index: item.employment_rate.split(" ")[0],
            //     cite: item.employment_rate.split("% ")[1],            
            //     label: 'Employment Rate',
            //     textColor: 'text--fes-blue',
            //     cols: "4"
            // }, 
            {
                id: 'housing',
                color: '#F1E3ED',
                text: JSON.parse(item.housing),
                label: 'Housing',
                textColor: 'text--fes-magenta',
                cols: "12"
            },   
          ]
          return hellow;
        }
      } else {
        return '';
      }
    }, 
    referenceList() {
      if (this.panelContent.city) {
        const item = JSON.parse(this.panelContent.refList);
        return item;
      } else {
        return '';
      }
    },
    partnerList() {
      if (this.panelContent.city) {
        const item = JSON.parse(this.panelContent.partnerList);
        return item;
      } else {
        return '';
      }
    },
    videoList() {
      if (this.panelContent.city) {
        const item = JSON.parse(this.panelContent.video);
        return item;
      } else {
        return '';
      }
    }     
  },  
  data() {
    return {
      mapCards: [
        { id: 'people', color: '#E9ECFB', amt: '21.89', label: 'No. of inhabitants', textColor: 'text--fes-blue'},
        { id: 'cars', color: '#E9ECFB', amt: '21.89', label: 'No. of cars', textColor: 'text--fes-blue' },
        { id: 'bikes', color: '#E9ECFB', amt: '21.89', label: 'BIKE LANES', textColor: 'text--fes-blue'},
        { id: 'transport', color: '#E9ECFB', amt: '21.89', label: 'Public transport', textColor: 'text--fes-blue' },
        { id: 'waste', color: '#EAF4E4', amt: '21.89', label: 'Waste', textColor: 'text--fes-green'},
        { id: 'carbon', color: '#EAF4E4', amt: '21.89', label: 'Carbon emissions target', textColor: 'text--fes-green'},
      ],
    };
  },
  watch: {
    panelContent() {
      document.querySelector('.map-side-panel').scrollTo(0,0);
    },    
  },
  methods: {
    closePanel() {
      document.querySelector('.map-side-panel').scrollTo(0,0);
      this.$store.dispatch('contentPanel/updatePanelState', '');
    },      
    kebabCase(string) {
      return _kebabCase(string)
    }       
  },
}
</script>

<style scoped lang="scss">
.map-side-panel {
  position: fixed;
  z-index: 10;
  background-color: rgba(255, 255, 255, 1);
  border-radius: unset;

  // scrollbar
  overflow-y: scroll;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */ 
  &::-webkit-scrollbar {
    display: none;    
  }

  .card-wrapper {
    position: relative;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */ 
    &::-webkit-scrollbar {
      display: none;    
    }    
  }

  .panel-close {
    position: fixed;
    top: 16px;
    left: calc(720px - 36px);
    border-radius: 50% !important;
    background-color: rgba(250, 250, 250, 0.72);
    padding: 4px;
    margin-right: 8px;
    z-index: 15;

    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      right: 8px;
      top: unset;
      left: unset;
      bottom: calc(50vh - 40px);
    }
  }    

  div.card-city-name {
    p {
      display: inline-block;
    }

    img {
      vertical-align: middle;
      margin-right: 8px;
    }
  }

  div.content-block p:last-child {
    margin-bottom: 0;
  }

  div.card-learn-more:last-child {
    margin-bottom: 0 !important;
  }
  
  div.card-references {
    background-color: #ECF6F9;
    padding: 24px;

    p:last-child {
      margin-bottom: 0 !important;
    }
  }

  .content-map-cards {
    div.card-item {
      width: 100%;
      // display: flex;
      // flex-direction: column;   

      .card-icon {
        display: block;
        margin-left: auto;
        width: 40px;      
      }
    }

    @media #{map-get($display-breakpoints, 'sm-and-down')} { 
      div.sub-card {
        display: inline;
        p { 
          display: inline;
          margin-right: 4px;
        }
      }

      div.card-item {
        width: 100%;
        display: flex;
        align-items: center;
        div {
          margin-right: 16px;
        }

        .card-icon {
          display: block;
        }
      }

    }
  }

  .content-map-cards:nth-child(9) {
    div.card-item {
      margin-bottom: 0px !important;
    }
  }

  .content-video-wrapper {
    .video {
      width: 100%;
      height: 350px;

      @media #{map-get($display-breakpoints, 'sm-and-down')} {
        height: 225px;
      }
    }
  }
}

.map-side-panel--desktop {
  max-width: 720px; 
  height: 100vh;
  max-height: 100vh;
  top: 0;
  // left: calc(-5.25 / 12 * 100vw);
  left: -720px;
  transition: left 0.5s ease 0s;  
  padding-top: 48px;
  padding-bottom: 36px;
  
  &.--is-open {
    left: 0;
    transition: left 0.5s ease 0s;  
  }
}

.map-side-panel--mobile {
  width: 100%; 
  max-height: 50vh;
  bottom: -50vh;
  left: 0;
  padding-top: 24px;
  padding-bottom: 40px;  
  transition: bottom 0.5s ease 0s;  
  
  &.--is-open {
    bottom: 0;
    transition: bottom 0.5s ease 0s;  
  }
}

.fade-leave-active {
  transition: opacity 0s;
}

.fade-enter-active{
  transition: opacity 2.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>